import { agencyPath, createRequestWithComputedFilters } from '@/utils/api'
import network from '@/utils/network'

/**
 * Récupère les templates de contrats clients
 * @param filters
 * @param opt
 * @returns {Promise}
 */
export const fetchAgencyCustomerContractsTemplates = createRequestWithComputedFilters(
  async (params) => {
    const r = await network.post(`${agencyPath()}/fetch/contracts/templates/customers`, params)
    return r.data
  })

/**
 * Récupère les templates par défaut des contrats client
 * @returns {Promise<>}
 */
export const postAgencyCustomerContractTemplate = async (customerContractTemplate) => {
  const r = await network.post(`${agencyPath()}/contract/template/customer`, customerContractTemplate)
  return r.data
}

/**
 * Supprime un template de contrat client
 * @returns {Promise<>}
 */
export const deleteAgencyCustomerContractTemplate = async (id) => {
  const r = await network.delete(`${agencyPath()}/contract/template/customer/${id}`)
  return r.data
}
